import { useState } from "react";
import axios from "axios";

const CreateBodyMember = () => {
  const [form, setForm] = useState({
    name: "",
    role: "",
    photo: null,
    start_date: "",
    end_date: "",
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "photo") {
      setForm({ ...form, photo: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("role", form.role);
    formData.append("photo", form.photo);
    formData.append("start_date", form.start_date);
    formData.append("end_date", form.end_date);

    try {
      const res = await axios.post(
        "https://gp-chandoli-khurd.com/backend/api/body_members/post_body_member.php",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      alert(res.data.message);

      // Reset form state
      setForm({
        name: "",
        role: "",
        photo: null,
        start_date: "",
        end_date: "",
      });

      // Reset file input manually
      e.target.reset();

    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="p-5">
      <h2 className="text-xl font-semibold mb-4">Add Body Member</h2>

      <form onSubmit={handleSubmit} className="space-y-3">

        <input
          type="text"
          name="name"
          value={form.name}
          placeholder="Name"
          onChange={handleChange}
          className="border p-2 w-full"
        />

        <input
          type="text"
          name="role"
          value={form.role}
          placeholder="Role"
          onChange={handleChange}
          className="border p-2 w-full"
        />

        <input
          type="file"
          name="photo"
          accept="image/*"
          onChange={handleChange}
          className="border p-2 w-full"
        />

        <input
          type="date"
          name="start_date"
          value={form.start_date}
          onChange={handleChange}
          className="border p-2 w-full"
        />

        <input
          type="date"
          name="end_date"
          value={form.end_date}
          onChange={handleChange}
          className="border p-2 w-full"
        />

        <button className="bg-blue-500 text-white px-4 py-2 rounded">
          Save
        </button>

      </form>
    </div>
  );
};

export default CreateBodyMember;